(() => {
  const callback = () => {
    // Replace the product category with the collection the customer came from
    const isCameFromCollection = document.referrer.includes('/collections/');
    const collectionData = JSON.parse(sessionStorage.getItem('previousCollection'));
    if (!isCameFromCollection || !collectionData) return;

    const categoryLinks = document.querySelectorAll(
      '.breadcrumbs__item[data-show-last-collection=true]',
    );
    categoryLinks.forEach((link) => {
      link.textContent = collectionData.title.toLowerCase();
      link.href = `/collections/${collectionData.handle}`;
    });
  };

  document.addEventListener('DOMContentLoaded', callback);
})();
